import {
    useMutationReadNotifications,
    useQueryInfiniteAllNotificationAlert,
    useQueryNotificationAlertCountUnread,
} from '@/api/queries/notification';
import ChecksIcon from '@/assets/icons/checks.svg';
import CircleDottedIcon from '@/assets/icons/circle-dotted.svg';
import DrawPolygonIcon from '@/assets/icons/lasso-polygon.svg';
import MapPinIcon from '@/assets/icons/map-pin.svg';
import SquareIcon from '@/assets/icons/square.svg';

import PolylineIcon from '@/assets/icons/vector-spline.svg';
import NotificationItem from "@/featured/apps/components/notification/components/NotificationItem";
import {NotificationItemSkeleton} from "@/featured/apps/components/notification/components/NotificationItemSkeleton";
import {NotificationAlertZone} from '@/types/api';
import clsx from 'clsx';

import {Fragment} from 'react';
import toast from 'react-hot-toast';

type Props = {};

export default function NotificationZone({}: Props) {
    const dataNotificationZone = useQueryInfiniteAllNotificationAlert('zones', 'received_at', 'desc');

    const notificationAlertCountUnread = useQueryNotificationAlertCountUnread();

    const {isPending: isPendingReadNotification, mutateAsync: readNotification} =
        useMutationReadNotifications();

    const listIcons = (geofenceType: string) => {
        switch (geofenceType) {
            case 'circle':
                return <CircleDottedIcon className="h-5 w-5"/>;
            case 'polygon':
                return <DrawPolygonIcon className="h-5 w-5"/>;
            case 'rectangle':
                return <SquareIcon className="h-5 w-5"/>;
            case 'polyline':
                return <PolylineIcon className="h-5 w-5"/>;
            default:
                return <MapPinIcon className="h-5 w-5"/>;
        }
    };

    if (
        dataNotificationZone.isLoading ||
        dataNotificationZone?.isFetchingNextPage ||
        isPendingReadNotification
    )
        return <NotificationItemSkeleton/>;

    // @ts-ignore
    if ((dataNotificationZone?.data?.pages?.[0]?.data || []).length === 0)
        return (
            <h2 className="focus:outline-none text-sm leading-normal text-center pt-8 pb-2 border-gray-300 text-gray-600 notification-center">
                Notification Empty
            </h2>
        );
    return (
        <div className="max-2xl:w-full h-auto overflow-y-auto py-2 px-4 absolute right-0">
            {(notificationAlertCountUnread?.data?.notification_zone ?? 0) !== 0 && (
                <button
                    disabled={(notificationAlertCountUnread?.data?.notification_zone ?? 0) === 0}
                    onClick={() => {
                        readNotification('zones');
                        toast.success('All zone notifications marked as read');
                    }}
                    className={clsx(
                        'text-slate-500 hover:text-green-500 mb-2 flex items-center justify-center gap-2 float-right',
                    )}
                >
                    Mark All as Read <ChecksIcon className="h-5 w-5"/>
                </button>
            )}

            {!dataNotificationZone?.isLoading && (
                <>
                    {dataNotificationZone?.data?.pages.map((group: any, i: any) => (
                        <Fragment key={i}>
                            {group.data.map((item: NotificationAlertZone) => (
                                <NotificationItem
                                    key={item?.id}
                                    message={
                                        item?.alert_type === 'entry' || item?.alert_type === 'in_zone'
                                            ? `<p class='text-blue-400'>${item.message}</p>`
                                            : item?.alert_type === 'exit'
                                            ? `<p class='text-red-400'>${item.message}</p>`
                                            : `<p class='text-amber-400'>${item.message}</p>`
                                    }
                                    Icon={listIcons(item?.type_geofence)}
                                    date={item.received_at}
                                    isRead={
                                        !!item.open_at ||
                                        (notificationAlertCountUnread?.data?.notification_zone ?? 0) === 0
                                    }
                                />
                            ))}
                        </Fragment>
                    ))}

                    {dataNotificationZone.hasNextPage && (
                        <div className="flex justify-center items-center">
                            <button
                                className="focus:outline-none bg-gray-100 text-slate-600 p-3 py-1 rounded-lg text-xs mt-4"
                                onClick={() => dataNotificationZone.fetchNextPage()}
                            >
                                Load More
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
